import { FieldValues, UseFormTrigger } from 'react-hook-form';

import { IResponseError } from '@interfaces/errors/apiErrors';

import { EErrorCodes } from '@enums/errorCodes';

import { NETWORK_ELEMENT_TYPES } from '../constants';

export const determineElementPathFlags = (type?: string) => {
	switch (type) {
		case NETWORK_ELEMENT_TYPES.CUDU:
			return { isCuPath: true, isDuPath: true };
		case NETWORK_ELEMENT_TYPES.DU:
			return { isCuPath: false, isDuPath: true };
		case NETWORK_ELEMENT_TYPES.CU:
			return { isCuPath: true, isDuPath: false };
		default:
			return { isCuPath: false, isDuPath: false };
	}
};

export const createVesPathGetter = async (
	getPath: (params: { id: string }) => Promise<{ path: string }>,
	setValue: (key: string, value: string) => void,
	id: string,
	setValueKey: string,
	trigger: UseFormTrigger<FieldValues>,
) => {
	try {
		const { path } = await getPath({ id });

		if (path) {
			setValue(setValueKey, path);
			await trigger(setValueKey);
		}

	} catch (e) {
		return;
	}
};

export const isNetworkElementError = (err: IResponseError) => {
	return err.errors.find((item) =>
		item.code === EErrorCodes.networkElementNotEnabled ||
		item.code === EErrorCodes.networkElementNotConnected,
	);
};
